export default __webpack_public_path__ + "static/media/travelbox.a6e596a5.png";